import { Component, computed, inject, signal, viewChild } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Config } from './configs/index.config';
import { InputService, LoaderComponent } from 'ets-fe-ng-sdk';
import { SharedAppComponent } from 'projects/evolutics-shared-lib/src/lib/shared-app.component';
import { MatProgressBar } from '@angular/material/progress-bar';
import { UserPreviewModalComponent } from '@Shared/components/user-preview-modal/user-preview-modal.component';
import { ToastNotificationsComponent } from '@serene-dev/toast-notifications';
import { UserHelperComponent } from '../../../evolutics-shared-lib/src/lib/Shared/components/page-icons/user-helper/user-helper.component';
import { CMSService } from '@Reusables/reusable-pages/cms/cms.service';
import { environment } from '../environments/environment';
import { WindowPrinterComponent } from '../../../evolutics-shared-lib/src/lib/Shared/components/print-components/window-printer/window-printer.component';
import { VerticalNavComponent } from '../../../evolutics-shared-lib/src/lib/Layout/navigation/vertical-nav/vertical-nav.component';
import { FilterMenuArrayPipe } from '../../../evolutics-shared-lib/src/lib/Shared/pipes/utility.pipe';
import { AsyncPipe, CommonModule, NgTemplateOutlet } from '@angular/common';
import { UserCalendarService } from '@Reusables/reusable-pages/user-calendar/user-calendar.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    MatProgressBar,
    LoaderComponent,
    RouterOutlet,
    // ChatHelpDeskComponent,
    UserPreviewModalComponent,
    ToastNotificationsComponent,
    UserHelperComponent,
    VerticalNavComponent,
    FilterMenuArrayPipe,
    AsyncPipe,
    CommonModule,
  ],
  providers: [],
})
export class AppComponent extends SharedAppComponent {
  protected readonly cmsService = inject(CMSService);
  protected readonly inputService = inject(InputService);
  protected readonly userCalendarService = inject(UserCalendarService);
  readonly UserPreviewModalComponentRef = viewChild(UserPreviewModalComponent);
  readonly allowProfilePreview = signal(false);
  readonly menuItems = computed(() => {
    return this.uS.isMobileSignal() ? this.appS.topMenu : this.appS.currentBottomMenu();
  });
  readonly showMenu = computed(() => this.appS.showVerticalMenu());
  readonly userIsSuperAdmin = computed(() => environment.userIsSuperAdmin);

  async ngOnInit() {
    super.ngOnInit();
    this.cmsService.getResourceFormatter = (q) => ({ ...q, language: environment.targetLanguage });
    // this.inputService.updateConfig({ timeType: '24H' });
    this.userHelperService.updateConfig({
      // hiddenModules: { [EUserHelperID.quote]: true, [EUserHelperID.notification]: true },
      applicationCode: 'EV',
      // searchHelpFunction: (query) =>
      //   this.cmsService.getPageRelatedResources({
      //     applicationCode: 'JP',
      //     moduleType: ECMSModuleType.help,
      //     refCat: ECMSContentRefCat.menuItem,
      //     refId: query.path,
      //   }),
      viewTaskRoute: `workflow-desk/view/index?code=`,
    });
    this.searchS.buildIndex();

    this.appS.systemMetadataMap = Config.systemMetadataMap as any;
    if (this.authService.isLoggedin) {
      this.authService.getAllFromLocal();
      this.authService.getAllFromOnline();
    }
    ['createdBy', 'updatedBy'].forEach((fieldName) => {
      this.uS.tableService.generalColumnPropMap[fieldName] = {
        onHoverHandler: {
          action: (row, event) => {
            if (this.allowProfilePreview())
              this.UserPreviewModalComponentRef()?.open(event as PointerEvent, {
                userName: row?.[fieldName],
              });
            else {
              this.allowProfilePreview.set(true);
              setTimeout(() => {
                this.UserPreviewModalComponentRef()?.open(event as PointerEvent, {
                  userName: row?.[fieldName],
                });
              }, 600);
            }
          },
          delay: 1000,
        },
      };
    });
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
  }
}
